import type { IntentOut } from "@/api/client";

import type { MicrophoneAccess } from "./microphone";

export type LaunchDecision =
  | { readonly kind: "idle" }
  | { readonly kind: "starting"; readonly intent: IntentOut }
  | { readonly kind: "auto_start"; readonly intent: IntentOut }
  | { readonly kind: "await_designer"; readonly intent: IntentOut }
  | { readonly kind: "recording"; readonly intent: IntentOut };

export type LinkAction = "begin" | "ignore";

export function decideLink(adopted: IntentOut | null, busy: boolean): LinkAction {
  if (busy) return "ignore";
  if (adopted && adopted.state !== "pending" && adopted.state !== "claimed") {
    return "ignore";
  }
  return "begin";
}

export interface LaunchContext {
  readonly intents: readonly IntentOut[];
  readonly access: MicrophoneAccess;
  readonly busy: boolean;
  readonly ownedIntentId: string | null;
}

export function decideLaunch(context: LaunchContext): LaunchDecision {
  const owned = context.intents.find(
    (intent) => intent.intent_id === context.ownedIntentId,
  );
  if (owned) {
    return owned.state === "recording"
      ? { kind: "recording", intent: owned }
      : { kind: "starting", intent: owned };
  }
  const candidate = context.intents.find((intent) => intent.auto_start);
  if (!candidate) return { kind: "idle" };
  if (context.busy || context.access === "denied") {
    return { kind: "await_designer", intent: candidate };
  }
  const firstTry = candidate.attempts === 0;
  return firstTry || context.access === "granted"
    ? { kind: "auto_start", intent: candidate }
    : { kind: "await_designer", intent: candidate };
}
